export const formatOptions = (arr) =>
  arr.map((item) => ({ value: item, label: item }));

export function formatNumber(
  value: number | string,
  options?: { currency?: string; locale?: string }
): string {
  const { currency, locale = "en-US" } = options || {};

  if (typeof value === "string") value = Number(value);

  if (isNaN(value)) return "";

  return new Intl.NumberFormat(locale, {
    style: currency ? "currency" : "decimal",
    currency,
    maximumFractionDigits: 2,
  }).format(value);
}
